/**
 * Prism highlights every `pre > code[class*="language-"]` on the page shortly
 * after it loads, which would rewrite the markup Vue owns through v-html. The
 * opt-out is read while the library evaluates, so it has to be set from a
 * module imported ahead of it.
 */
const globalWithPrism = window as typeof window & {
  Prism?: { manual?: boolean }
}

globalWithPrism.Prism = { ...globalWithPrism.Prism, manual: true }

export {}
